import Areas from './Areas';
export default Areas;